import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="section white">
      <div className="container" style={{ textAlign: "center", paddingTop: "3rem", paddingBottom: "3rem" }}>
        <h1>Page not found</h1>
        <p className="muted">
          Sorry, I couldn't find the page you were looking for. It may have moved, or the link may be mistyped.
        </p>
        <nav
          aria-label="Helpful links"
          style={{ display: "flex", gap: ".75rem", justifyContent: "center", flexWrap: "wrap", marginTop: "1.5rem" }}
        >
          <Link className="btn-cta" to="/">Home</Link>
          <Link className="btn-cta" to="/#services">Services</Link>
          <Link className="btn-cta" to="/#contact">Contact</Link>
        </nav>
      </div>
    </section>
  );
}
